// import React, { useEffect, useState } from "react";

// const steps = [
//   "Deploying files...",
//   "Syncing domain...",
//   "Publishing website...",
//   "Finalizing setup..."
// ];

// const GoLiveLoader = ({ onComplete }) => {
//   const [progress, setProgress] = useState(0);
//   const [stepIndex, setStepIndex] = useState(0);

//   useEffect(() => {
//     let count = 0;
//     const interval = setInterval(() => {
//       count++;

//       setProgress((prev) => prev + 25);
//       setStepIndex((prev) => prev + 1);

//       if (count === 4) {
//         clearInterval(interval);
//         setTimeout(() => {
//           onComplete(); // redirect to WebsiteLive
//         }, 500);
//       }
//     }, 15000); // 15 sec per step → 60 sec total

//     return () => clearInterval(interval);
//   }, [onComplete]);

//   return (
//     <div className="flex flex-col items-center justify-center h-full bg-white">
//       <div className="w-2/3 bg-gray-300 rounded-full overflow-hidden">
//         <div
//           className="h-4 bg-blue-600 transition-all duration-700"
//           style={{ width: `${progress}%` }}
//         ></div>
//       </div>

//       <h2 className="text-xl mt-5 font-bold text-gray-700">
//         {steps[stepIndex] || "Starting process..."}
//       </h2>

//       <p className="mt-2 text-gray-600">{progress}% completed</p>

//       <div className="mt-8 flex gap-3">
//         {steps.map((_, i) => (
//           <div
//             key={i}
//             className={`w-4 h-4 rounded-full ${
//               i < stepIndex ? "bg-blue-600" : "bg-gray-400"
//             }`}
//           ></div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default GoLiveLoader;

import React, { useEffect, useState } from "react";

const steps = [
  "Deploying files...",
  "Syncing domain...",
  "Publishing website...",
  "Finalizing setup..."
];

const GoLiveLoader = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    const totalTime = 60000; // 60 seconds
    const frames = 200; // how many updates for smoothness
    const intervalTime = totalTime / frames;
    const increment = 100 / frames;

    const interval = setInterval(() => {
      setProgress((prev) => {
        const next = prev + increment;
        const clamped = next >= 100 ? 100 : next;

        // update step based on new progress
        const newIndex = Math.min(
          steps.length - 1,
          Math.floor(clamped / (100 / steps.length))
        );
        setStepIndex(newIndex);

        return clamped;
      });
    }, intervalTime);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      onComplete(); //  now this will fire after ~60s
    }, totalTime);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [onComplete]); // <-- run once, no progress here

  return (
    <div className="flex flex-col items-center justify-center h-full w-full bg-white">
      <div className="w-2/3 bg-gray-300 rounded-full overflow-hidden">
        <div
          className="h-4 bg-blue-600 transition-all"
          style={{ width: `${progress}%` }}
        />
      </div>

      <h2 className="text-lg mt-5 font-bold text-gray-700">
        {steps[stepIndex]}
      </h2>

      <p className="text-gray-600 text-sm">
        {Math.floor(progress)}% completed
      </p>

      <div className="mt-4 flex gap-2">
        {steps.map((_, i) => (
          <div
            key={i}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              i <= stepIndex ? "bg-blue-600" : "bg-gray-400"
            }`}
          />
        ))}
      </div>

      <p className="mt-6 text-gray-400 text-xs tracking-wider">
        This may take up to 1 minute...
      </p>
    </div>
  );
};

export default GoLiveLoader;
